import { useContext } from 'react';

import type { IAuthContextValue } from '../AuthContext';
import { AuthContext } from '../AuthContext';

/**
 * Use the `useAuth` hook in your components to access the auth state and
 * methods.
 */
export const useAuth = (context = AuthContext): IAuthContextValue =>
  useContext(context);
